( function () {
	'use strict';

	function EvidenceTimer ( logger, $scope, $filter, _, $modal, $timeout, TOOLTIP_MESSAGES, evidenceService ) {
		var self = this;

		var changeTimeReceiver, changeLabelReceiver;

		$scope.$watch( 'model.masterEvidences', function ( val ) {
			if ( val ) {
				var newTimer    = _.filter( val, 'id',  $scope.timerEvidence.id )[ 0 ];

				self.timerTitle = newTimer.name;
			}
		}, true );

		function stripMs ( newTime ) {
			return newTime.substring( 0, newTime.length - 1 );
		}

		function deleteTimer () {
			var deleteEvidence = _.find( $scope.model.masterEvidences, { 'id' : self.prevUUID } );

			if ( deleteEvidence ) {
				evidenceService.editDeleteEvidence( deleteEvidence, 'delete', $scope.model );
			}

			$scope.time.splice( $scope.index, 1 );
		}

		function deleteConfirmationModal () {
			self.modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'type' : function () {
						return 'Evidence';
					}
				}
			} );

			self.modalInstance.result.then( function () {
				$scope.$root.$broadcast( 'delete:timer', $scope.timerEvidence.id );
				deleteTimer();
			} );
		}

		function setTimeText ( time ) {
			angular.element( '#timer-' + $scope.index ).text( time );
			self.time = time;
		}

		self.startStop = function ( start ) {
			var buttonLabel = {
				'true'  : 'Stop',
				'false' : 'Start'
			};

			if ( start ) {
				self.timerStarted  = false;
				self.tempStartTime = false;
			} else {
				self.startTimer = true;
			}

			// add timeout to instant update the label
			$timeout( function () {
				self.timeButton = buttonLabel[ start ];
			} );
		};

		self.clearTimer = function () {
			$scope.timerEvidence.description = '00:00:00.00';
			$scope.$root.$broadcast( 'clear:time:',  $scope.timerEvidence.id );
		};

		self.checkEnterKey = function ( ev ) {
			if ( ev.keyCode === 13 ) {
				ev.preventDefault();
			}

			if ( self.timerTitle ) {
				$scope.timerEvidence.name = self.timerTitle;
				self.invalidTitle         = false;
				evidenceService.editDeleteEvidence( $scope.timerEvidence, 'edit', $scope.model );
				return true;
			}

			self.invalidTitle = true;
		};

		self.triggerStartStop = function () {
			if ( self.timeButton === 'Start' ) {
				$scope.$root.$broadcast( 'start:time:', $scope.timerEvidence.id );
			} else {
				$scope.timerEvidence.description = self.time;
				evidenceService.editDeleteEvidence( $scope.timerEvidence, 'edit', $scope.model );
				$scope.$root.$broadcast( 'stop:time:', $scope.timerEvidence.id );
			}
		};

		function activate () {
			logger.info( 'Activated Timer View' );

			$scope.$root.$broadcast( 'check:timer:', $scope.timerEvidence.id );

			self.tooltip       = TOOLTIP_MESSAGES;
			self.startTimer    = true;
			self.timerStarted  = true;
			self.showOverlay   = false;
			self.tempStartTime = true;
			self.timeButton    = 'Start';
			self.timerTitle    = $scope.timerEvidence.name || 'Timer ' + ( $scope.index + 1 );
			self.prevUUID      = $scope.timerEvidence.id;

			// scope calls for time synchronization
			changeTimeReceiver  = 'change:time:' + $scope.timerEvidence.id;
			changeLabelReceiver = 'change:label:timer:qa:' + $scope.timerEvidence.id;
			// end for scope calls

			if ( !$scope.timerEvidence.description ) {
				self.clearTimer();
			} else {
				self.timer = $scope.timerEvidence.timerData;
				self.time  = $scope.timerEvidence.description;
				$timeout( function () {
					setTimeText( $scope.timerEvidence.description );
				}, 1 );
			}
		}

		self.deleteConfirm = deleteConfirmationModal;

		activate();

		$scope.$on( 'check:running:timer:counter', function ( event, deleteEvidence ) {
			if ( self.prevUUID === deleteEvidence.id ) {
				$scope.time.splice( $scope.index, 1 );
			}
		} );

		$scope.$on( changeLabelReceiver, function ( ev, start, time ) {
			setTimeText( stripMs( time ) );
			self.startStop( start );
		} );

		$scope.$on( changeTimeReceiver, function ( ev, updatedTime ) {
			setTimeText( updatedTime );
		} );

		$scope.$on( 'save:timer', function () {
			if ( self.timeButton !== 'Start' ) {
				self.triggerStartStop();
			}
		} );
	}

	angular
		.module( 'app.templates' )
		.controller( 'EvidenceTimer', EvidenceTimer );

	EvidenceTimer.$inject = [ 'logger', '$scope', '$filter', '_', '$modal', '$timeout', 'TOOLTIP_MESSAGES', 'evidenceService' ];
} )( );
